module.exports = __webpack_public_path__ + "img/eems.706cd9e3.svg";